import React from 'react';
import './blog.css';

export function Blog() {
  const blogPosts = [
    {
      id: 1,
      title: 'Yellow is Best Colour',
      date: 'June 13, 2024',
      content: 'Yell-ow! Yell-ow! Yell-ow! We all can do with a little more yellow in our life.',
    },
    {
      id: 2,
      title: 'Vaporeon is Best Pokêmon',
      date: 'June 13, 2024',
      content: 'In my first blog post ever, I want to address something very important: Vaporeon is inarguably the best Pokémon. I will not lie, Wiglett poses some decent competition especailly in the new Pokémon stuffie of 10.75 inches. However, if you really think about it, Wiglett is simply a white Diglett - it is not original. Vaporeon, on the other hand, is a prime example of a Gen 1 Pokémon in its peak form. ',
    },
  ];

  return (
    <div className="blog">
      <div className="note">I find journalling as a way to release stress and reflect on some of my thoughts. Find some of them here!</div>
      <div className="blog__posts">
        {blogPosts.map((post) => (
          <div key={post.id} className="blog__post">
            <h2>{post.title}</h2>
            <p className="blog__date">{post.date}</p>
            <p>{post.content}</p>
          </div>
        ))}
      </div>
    </div>
  );
};
